import type { StoreData } from "@features/stores/types";
import { activeSiteConfig } from "@config/site/site-config";
import type { Cart } from "@graphql/generated/types";
import { ExtraPriceType } from "@lib/constants/filtersConstants";

export const checkClickAndCollectAvailability = (cart: Cart, storeData: StoreData) => {
    if (!cart?.lineItems?.length || !storeData?.supplyChannel?.[0]?.id) {
        return false;
    }

    return cart.lineItems.every((item) =>
        item?.variant?.availability?.channels?.results?.some(
            (variant) =>
                variant?.channel?.id === storeData.supplyChannel[0].id &&
                variant.availability.isOnStock
        )
    );
};

type DiscountParams = {
    isDiscounted: boolean;
    currentPrice: number;
    previousLowestPrice?: number;
    recommendedPrice?: number;
    discountPercentage?: number;
    discountPercentagePreviousLowest?: number;
};

export function getDiscountToDisplay({
    isDiscounted,
    currentPrice,
    previousLowestPrice,
    recommendedPrice,
    discountPercentage,
    discountPercentagePreviousLowest,
}: DiscountParams): number {
    if (!isDiscounted) return 0;

    const isOmnibusMarket =
        activeSiteConfig?.extraPriceType?.includes(ExtraPriceType.OMNIBUS) ?? false;

    // Non-omnibus markets → use standard discount
    if (!isOmnibusMarket) {
        return discountPercentage ?? 0;
    }

    // Omnibus price available
    if (previousLowestPrice) {
        if (previousLowestPrice <= currentPrice) return 0;

        return discountPercentagePreviousLowest ?? discountPercentage ?? 0;
    }

    // Omnibus price missing → fallback to RRP
    if (recommendedPrice && recommendedPrice > currentPrice) {
        return discountPercentage ?? 0;
    }

    return 0;
}

export const convertPathnameToCategory = (pathname: string): string => {
    return decodeURIComponent(
        pathname.slice(1, pathname.indexOf("?") === -1 ? undefined : pathname.indexOf("?"))
    ).replaceAll("/", ">");
};
